import { uiState } from "../../state/uiState.js";
import { renderUyeliklerGrid, clearUyeliklerGrid } from "./uyeliklerGrid.js";
import { truncateLabel } from "../../utils/textPresentation.js";

const API = "/api";
let didBound = false;

function showFilterOverlay(container) {
    let ov = container.querySelector(".filter-loading-overlay");
    if (!ov) {
        ov = document.createElement("div");
        ov.className = "filter-loading-overlay";
        ov.innerHTML = `<div class="filter-loading-spinner"></div><span class="filter-loading-text">Yükleniyor...</span>`;
        container.appendChild(ov);
    }
    ov.classList.remove("hidden");
}

function hideFilterOverlay(container) {
    container.querySelector(".filter-loading-overlay")?.classList.add("hidden");
}

async function withFilterOverlay(container, fn) {
    showFilterOverlay(container);
    try { await fn(); }
    finally {
        await new Promise(r => setTimeout(r, 300));
        hideFilterOverlay(container);
    }
}

export function resetUyeliklerFilters() {
    const yetkiSelect = document.querySelector("#uyelikler-yetki-filter");
    const durumSelect = document.querySelector("#uyelikler-durum-filter");
    const adInput = document.querySelector("#uyelikler-ad-filter");
    const soyadInput = document.querySelector("#uyelikler-soyad-filter");
    const tcInput = document.querySelector("#uyelikler-tc-filter");
    const badge = document.querySelector("#uyelikler-filter-section .filter-aktif-badge");
    const countEl = document.getElementById("uyelikler-count");

    if (yetkiSelect) yetkiSelect.value = "";
    if (durumSelect) durumSelect.value = "";
    if (adInput) adInput.value = "";
    if (soyadInput) soyadInput.value = "";
    if (tcInput) tcInput.value = "";

    uiState.uyelikler.filters.yetki_id = "";
    uiState.uyelikler.filters.durum = "";
    uiState.uyelikler.filters.ad = "";
    uiState.uyelikler.filters.soyad = "";
    uiState.uyelikler.filters.tc = "";

    clearUyeliklerGrid();
    if (badge) badge.hidden = true;
    if (countEl) countEl.textContent = "";
}

export function initUyeliklerFilters() {
    const sectionBody = document.querySelector("#uyelikler-filter-section .section-body");
    const yetkiSelect = document.querySelector("#uyelikler-yetki-filter");
    const durumSelect = document.querySelector("#uyelikler-durum-filter");
    const adInput     = document.querySelector("#uyelikler-ad-filter");
    const soyadInput  = document.querySelector("#uyelikler-soyad-filter");
    const tcInput     = document.querySelector("#uyelikler-tc-filter");
    const searchBtn   = document.querySelector(".uyelikler-search");
    const resetBtn    = document.querySelector(".uyelikler-filter-reset");
    const badge       = document.querySelector("#uyelikler-filter-section .filter-aktif-badge");

    async function loadDropdown(url, selectEl) {
        while (selectEl.options.length > 1) selectEl.remove(1);
        try {
            const res = await fetch(`${API}${url}`);
            const data = await res.json();
            (data.items || []).forEach((item) => {
                const fullLabel = String(item.label || item.name || "");
                const opt = document.createElement("option");
                opt.value = item.id;
                opt.textContent = truncateLabel(fullLabel, 32);
                opt.title = fullLabel;
                selectEl.appendChild(opt);
            });
            const selected = selectEl.options?.[selectEl.selectedIndex];
            selectEl.title = selected?.title?.trim?.() || selected?.textContent?.trim() || "";
        } catch (err) {
            console.error(`❌ ${url} yüklenemedi:`, err);
        }
    }

    // Her sayfa ziyaretinde yeniden yükle
    if (sectionBody) {
        withFilterOverlay(sectionBody, () => loadDropdown("/yetkiler", yetkiSelect))
            .catch((err) => console.error("❌ Üyelikler dropdown init hatası:", err));
    } else {
        loadDropdown("/yetkiler", yetkiSelect)
            .catch((err) => console.error("❌ Üyelikler dropdown init hatası:", err));
    }

    if (didBound) return;
    didBound = true;

    yetkiSelect?.addEventListener("change", () => {
        uiState.uyelikler.filters.yetki_id = yetkiSelect.value;
    });
    durumSelect?.addEventListener("change", () => {
        uiState.uyelikler.filters.durum = durumSelect.value;
    });
    adInput?.addEventListener("input", () => {
        uiState.uyelikler.filters.ad = adInput.value.trim();
    });
    soyadInput?.addEventListener("input", () => {
        uiState.uyelikler.filters.soyad = soyadInput.value.trim();
    });
    tcInput?.addEventListener("input", () => {
        tcInput.value = tcInput.value.replace(/\D/g, "").slice(0, 11);
        uiState.uyelikler.filters.tc = tcInput.value;
    });

    searchBtn?.addEventListener("click", () => {
        const params = new URLSearchParams();
        const { yetki_id, durum, ad, soyad, tc } = uiState.uyelikler.filters;
        if (yetki_id) params.append("yetki_id", yetki_id);
        if (durum)    params.append("durum", durum);
        if (ad)       params.append("ad", ad);
        if (soyad)    params.append("soyad", soyad);
        if (tc)       params.append("tc", tc);
        const qs = params.toString();
        const url = qs ? `${API}/uyeler?${qs}` : `${API}/uyeler`;
        renderUyeliklerGrid({ url, paginationLimit: uiState.uyelikler.paginationLimit });
        if (badge) badge.hidden = !qs;
    });

    resetBtn?.addEventListener("click", () => {
        resetUyeliklerFilters();
    });
}
